import $ from "jquery";

$(document).ready(() => {
    $(".sales-block-select").each(function() {
      let classes = $(this).attr("class"),
        name = $(this).attr("name");
      let template = '<div class="' + classes + '" data-target="' + name + '">';
      let displayValue =
        $(this).val().length > 0 ? $(this).val() : $(this).attr("placeholder");
      template +=
        '<span class="sales-block-select-trigger">' + displayValue + "</span>";
      template += '<div class="sales-options">';
      $(this)
        .find("option")
        .each(function() {
          let select = $(this).attr("selected") ? "selection" : "";
          template +=
            '<span class="sales-option ' +
            select +
            '"' +
            ' data-value="' +
            $(this).attr("value") +
            '">' +
            $(this).html() +
            "</span>";
        });
      template += "</div></div>";
  
      $(this).wrap('<div class="sales-block-select-wrapper"></div>');
      $(this).hide();
      $(this).after(template);
    });
  
    $(".sales-block-select-trigger").on("click", function() {
      $("html").one("click", function() {
        $(".sales-block-select").removeClass("opened");
      });
      $(this)
        .parents(".sales-block-select")
        .toggleClass("opened");
      event.stopPropagation();
    });
    $(".sales-option").on("click", function() {
      let value = $(this).data("value");
      let isFirst = true;
      let showToggle = false;
      const target = $(this)
        .parents(".sales-block-select.sources")
        .data("target");
      $(this)
        .parents(".sales-block-select-wrapper")
        .find("select")
        .val($(this).data("value"));
      $(this)
        .parents(".sales-options")
        .find(".sales-option")
        .removeClass("selection");
      $(this).addClass("selection");
      $(this)
        .parents(".sales-block-select")
        .removeClass("opened");
      $(this)
        .parents(".sales-block-select")
        .find(".sales-block-select-trigger")
        .text($(this).text());
      $(this)
        .parents(".layout.block-sales-block")
        .find(".block-card")
        .each(function() {
          if (target) {
            $(this).removeClass("block-card__featured-article");
            if (value) {
              if ($(this).data(target) == value) {
                $(this).removeClass(`${target}-hide`);
              } else {
                $(this).addClass(`${target}-hide`);
              }
            } else {
              $(this).removeClass(`${target}-hide`);
            }
            if (
              isFirst &&
              !$(this)
                .attr("class")
                .includes("hide")
            ) {
              $(this).addClass("block-card__featured-article");
              isFirst = false;
            }
          }
          $(this).removeClass("toggle-show");
        });
      $(this)
        .parents(".layout.block-sales-block")
        .find(".block-sales-layout__toggle-button")
        .hide();
      $(this)
        .parents(".layout.block-sales-block")
        .find(".block-card")
        .not(".location-hide")
        .not(".issold-hide")
        .each(function(index) {
          if (index < 4) {
            $(this).addClass("toggle-show");
          } else if (!showToggle) {
            showToggle = true;
            $(this)
              .parents(".layout.block-sales-block")
              .find(".block-sales-layout__toggle-button")
              .show();
          }
        });
    });
  });
  


// WEBPACK FOOTER //
// ./client/src/site__scf001/components/blocks/sales-block/index.js